import { useWatch } from "react-hook-form";
import type { ActorRefFrom } from "xstate";
import type { transferArtworkMachine } from "@design-lab/entities/transfers-lab/model/transfer-artwork.machine";

/**
 * Hook to get the enhancement tier from the transfer artwork machine
 */
export function useTransferEnhancementTier(
  artworkActor: ActorRefFrom<typeof transferArtworkMachine> | null | undefined
): string {
  // Get snapshot from the actor if it exists
  const snapshot = artworkActor ? artworkActor.getSnapshot() : null;
  const formControl = snapshot?.context?.formControl;

  // Watch the enhancementTier field if form control exists
  // We must call useWatch unconditionally to satisfy React hook rules
  const enhancementTier = useWatch({
    ...(formControl && { control: formControl.control }),
    name: "enhancementTier",
    defaultValue: "full_enhancements" // Default enhancement tier
  });

  // If no form control, return default
  if (!formControl) {
    return "full_enhancements";
  }

  return String(enhancementTier);
}
